import {
  Directive,
  Input,
  ViewContainerRef,
  ComponentRef,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  OnDestroy,
  Type,
} from '@angular/core';
import { AbstractView, MenuItemExtended, Props } from '@core/interfaces';

@Directive({
  selector: '[appComponentHost]',
  standalone: true, 
})
export class ComponentHostDirective<T, P> implements OnChanges, OnDestroy {
  private componentRef: ComponentRef<T> | null = null;

  @Input() component?: Type<T>;
  @Input() routeItem?: MenuItemExtended<T>;
  @Input() componentHidden?: boolean = false;
  @Input() props?: Props<P> | Props<P>[] = [];
  @Output() instanceCreated = new EventEmitter<T>();

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['component']) {
      this.cleanup();
      this.loadComponent();
    }
  }

  ngOnDestroy(): void {
    this.cleanup();
  }

  private loadComponent(): void {
    if (this.component && !this.componentHidden) {
      this.componentRef = this.viewContainerRef.createComponent(
        this.component
      );

      if (this.props) {
        Object.entries(this.props).forEach(([key, value]) => {
          this.componentRef?.setInput(key, value);
        });
      }

      const instance = (this.componentRef.instance as AbstractView<T>);
      instance.setTabId(this.routeItem?.id);
      instance.setIsChildrenComponent(true);
      this.instanceCreated.emit(this.componentRef.instance);
    }
  }

  private cleanup(): void {
    if (this.componentRef) {
      this.componentRef?.destroy();
      this.componentRef = null;
      this.viewContainerRef.clear();
    }
  }
}
